import { render, staticRenderFns } from "./todo-footer.vue?vue&type=template&id=be9fba54&"
import script from "./todo-footer.vue?vue&type=script&lang=ts&"
export * from "./todo-footer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports